// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Utilities from "@apollo/client/utilities";

function getOperationDefinition(prim) {
  return Utilities.getOperationDefinition(prim);
}

var Graphql;

var Observables;

var Policies;

export {
  getOperationDefinition ,
  Graphql ,
  Observables ,
  Policies ,
}
/* @apollo/client/utilities Not a pure module */
